import { enqueue, flush, setupUnloadFlush } from './core'
import { getOrCreateSession, endCurrentSession } from './session'
import { setupDwellTracking } from './dwell'
import { Category } from './constants'

export { Events, Category, Config } from './constants'
export { vTrack } from './directive'
export { useDialogTrack, useFormTiming } from './composables'

let initialized = false

/**
 * 初始化埋点 SDK
 * 在 main.js 中调用：initTracker(app, router)
 */
export function initTracker(app, router) {
  try {
    if (initialized) return
    initialized = true

    getOrCreateSession()
    setupDwellTracking(router)
    setupUnloadFlush()
  } catch (e) {
    // SDK 初始化失败不影响应用
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Tracker] init failed:', e)
    }
  }
}

/**
 * 手动上报事件
 * @param {string} eventName 事件名
 * @param {object} params 事件参数
 * @param {string} category 事件类别 (auto/semi/manual)
 */
export function track(eventName, params = {}, category = Category.MANUAL) {
  try {
    enqueue({
      eventName,
      eventCategory: category,
      pagePath: window.location.hash.replace('#', '') || window.location.pathname,
      eventParams: params,
    })
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Tracker] track failed:', e)
    }
  }
}

/**
 * 绑定用户身份（登录后调用）
 */
export function identify(userId) {
  try {
    track('identify', { user_id: userId }, Category.AUTO)
  } catch { /* 静默 */ }
}

/**
 * 重置会话（退出登录时调用）
 */
export function resetSession() {
  try {
    endCurrentSession()
    flush()
  } catch { /* 静默 */ }
}
